import theme from '../../theme/news12'
import redesignedTheme from '../../theme/news12-redesign'

import css from 'styled-jsx/css'

export const search = css.div`
  /* Styling for the header to make it consistent width - remove when header styling is updated */

  form {
    display:flex;
    flex-direction:row;
    border-bottom: 4px solid ${redesignedTheme.colors.mineShaft};
  }
  
  button {
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    cursor: pointer;
    overflow: hidden;
    outline: none;
    color: ${redesignedTheme.colors.mineShaft};
    transition: 0.2s ease-in-out;
    font-size: 13.3px;
  }
  
  input[type="text"],
  input[type="button"],
  input[type="submit"],
  input {
    font-family: Graphik;
    font-size: 24px;
    line-height: 32px;
    width: calc(100% - 18px);
    color: ${redesignedTheme.colors.mineShaft};
    font-weight: normal;
    border-radius: 0;
    border: none;
    margin: 0;  
    padding: 0;  
    padding-bottom: 3px;
    display:block;
    font-style: normal;
    text-transform: initial;
    text-align: left;
    -webkit-appearance: none !important;
  }
  
  input:focus {
    outline: none;
  }
  
  input:not(:focus) + button {
    color: ${theme.colors.lightGray2};
    transition: 0.2s ease-in-out;
  }
  
  input:placeholder {
    color: ${theme.colors.mourineGray};
    transition: 0.2s ease-in-out;
  }    
  
  input:focus::placeholder {
    color: ${theme.colors.lightGray2};
    transition: 0.2s ease-in-out;
  }
  
  input:placeholder-shown:focus + button {
    color: ${theme.colors.lightGray2};
    transition: 0.2s ease-in-out;
  }  
  
  input:placeholder-shown:not(:focus) + button {
    color: ${theme.colors.mourineGray};
    transition: 0.2s ease-in-out;
  }

  button:hover {
    color: ${theme.colors.lightGray4} !important;
    transition: 0.2s ease-in-out;
  }

  h4 {
    font-size: 22px;
    line-height: 22px;
    padding-bottom: 4px;
    font-weight: 500;
    color: ${redesignedTheme.colors.mineShaft};
    margin: 0 0 16px 0;
    border: none;
    font-style: normal;
    text-transform: initial;
    text-align: left;
  }

  .section {
    width: 100%;
  }

  .results {
    width: 1px;
    flex-grow: 1;
  }

  .sidebar {
    width: 340px;
    flex-grow: 0;
  }

  .container-description > p {
    font-size: 15px;
    line-height: 24px;
    font-weight: normal;
    padding: 0;
    margin: 0;
    color: ${theme.colors.binaryGray};
  }

  .container-image {
    position: relative;
    width: 180px;
    min-width: 180px;
    margin-right: 32px;
  }

  .container-image > img {
    width: 100%;
    height: auto;
  }

  .date {
    font-weight: 400;
    font-size: 0.89em;
    color: ${theme.colors.olympus};
    margin-right: 10px;
  }

  .hitcount {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    color: ${theme.colors.lightGray4};
    font-style: normal;
    margin-top: 17px;
    margin-bottom: 6px;
  }
  
  .search-term {
    font-weight: 500;
  }

  .item {
    text-decoration: none;
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid ${theme.colors.vapor};
    padding: 24px 0;
  }

  .item:last-child {
    border: none;
    padding: 24px 0 48px 0;
  }

  .container-date {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .play-icon-container {
    background-color: ${redesignedTheme.colors.lightBlue};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 3px;
    border-radius: 50%;
  }

  .play-icon {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 4px 0 4px 6px;
    border-color: transparent transparent transparent #ffffff;
    margin: 0 0 0 2px;
  }


  @media only screen and (max-width: 1024px) {
    .sidebar {
      display: none;
    }

    .container-image {
      width: 184px;
      min-width: 184px;
      margin-right: 24px;
    }
  }

  @media only screen and (max-width: 767px) {
    h4 {
      font-size: 20px;
      line-height: 26px;
    }
    .container-description > p {
      font-size: 14px;
      line-height: 24px;
    }

    .container-image {
      width: 160px;
      min-width: 160px;
    }
  }

  @media only screen and (max-width: 539px) {
    h4 {
      font-size: 16px;
      line-height: 22px;
      padding-bottom: 8px;
    }

    .container-description {
      display: none;
    }

    .container-description > p {
      font-size: 12px;
      line-height: 19px;
    }

    .container-image {
      width: 128px;
      min-width: 128px;
      margin-right: 16px;
    }
  }

  @media only screen and (max-width: 374px) {
    h4 {
      font-size: 14px;
      line-height: 20px;
    }

    .date {
      font-size: 12px;
      line-height: 14px;
    }

    .container-image {
      width: 72px;
      min-width: 72px;
      margin-right: 8px;
    }
  }
  
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration {
    display: none;
  }
`
